'use client';

type CookieSettingsProps = {
  className?: string;
};
import styles from './CookieSettings.module.scss';
export const CookieSettings = (props: CookieSettingsProps) => {
  const {
    className
  } = props;
  let classes = styles.cookie_settings;
  if (className) {
    classes += ` ${className}`;
  }
  return <button className={classes} onClick={() => {
    if (typeof window !== 'undefined' && typeof window.ketch === 'function') {
      window.ketch('showConsent', {
        displayHint: 'experiences.consent.modal'
      });
    }
  }} data-sentry-component="CookieSettings" data-sentry-source-file="CookieSettings.tsx">
      Cookie Settings
    </button>;
};